import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import routes from "../../routes";
import { GlobalStyle } from "./style";
import CentralizeLayout from "../../layouts/centralize";
import DashboardLayout from "../../layouts/dashboard";
import FullpageLayout from "../../layouts/fullpage";
import SettingLayout from "../../layouts/setting";
import NoMatch from "../../components/noMatch";
import { InitAction } from "../../actions";
import MobileAlert from "./components/mobileAlert";
import { getToken } from "../../lib/tokenManager";
import { ConnectedRouter } from "connected-react-router";
import { history } from "../../configureStore";
import { Toast } from "../../components/toast";
import ImageUploadModal from "./components/imageUploadModal";
import DownloadToast from "./components/downloadToast";
import FeedbackModal from "./components/ticketModal";
import { FullScreenLoading } from "../../components/loading";
import DownloadModal from "./components/downloadModal";
import FeatureDeniedModal from "./components/accessDeniedOrReminderModals/featureDeniedModal";
import GuestDeniedModal from "./components/accessDeniedOrReminderModals/guestsDeniedModal";
import LongErrorModal from "./components/longErrorModal";
import ChangeAccessDeniedWarning from "./components/accessDeniedOrReminderModals/changeAccessDeniedWarning";
import PanelSelectionModal from "../../projectSpecificComponents/panelSelectionModal";
import PettyCashierSelectionModal from "../../projectSpecificComponents/pettyCashierSelectionModal";
import TeamAddOrEditModal from "../team/addOrEditModal";
import { Confirm } from "../../components/confirm";
import { SERVER_INTERRUPT_MESSAGES } from "../../constants/serverInterrupt";
import {
  COMPANIES_LIST,
  FORGET_PASSWORD,
  LOGIN,
  NEW_OR_EDIT_COMPANY,
  PURCHASE,
  REGISTER,
  RESET_PASSWORD,
  USER_ACCOUNT_SETTING_EDIT,
  VERIFY
} from "../../constants/urls";
import InitError from "./components/initError";
import { ACCESS_TOKEN, PROJECT_USER_ID } from "../../constants/storageKeys";
import {
  COMPLETE_PROJECT_INFO_CONFIRM,
  COMPLETE_USER_PROFILE_CONFIRM,
  WARNING_SINGLE_BUTTON_TEXT
} from "../../constants/otherTexts";
import { EDIT as EDIT_MODE } from "../../constants/companyFormType";
import { ToolsDashboardLayout, ToolsFullpageLayout } from "../../layouts/tools";
import { getQueryStringValue } from "../../sagas/auth";

let AUTH_ROUTES = [LOGIN, REGISTER, FORGET_PASSWORD, VERIFY, RESET_PASSWORD];
let COMPANIES_ROUTES = [COMPANIES_LIST, NEW_OR_EDIT_COMPANY];
let ALLOWED_ROUTES_BEFORE_PROJECT_SELECTION = [
  ...AUTH_ROUTES,
  ...COMPANIES_ROUTES,
  PURCHASE,
  USER_ACCOUNT_SETTING_EDIT
];
let ISOLATED_ROUTES_FROM_INIT = [
  ...AUTH_ROUTES,
  ...COMPANIES_ROUTES,
  USER_ACCOUNT_SETTING_EDIT
];
let FORBIDDEN_ROUTES_AFTER_PROJECT_SELECTION = [...AUTH_ROUTES, COMPANIES_LIST];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessDeniedModalShow: false
    };

    // const project_state = sessionStorage.getItem("project_state");
    // if (
    //   window.location.pathname !== PURCHASE &&
    //   project_state &&
    //   (parseInt(project_state) === USER_STATE.INACTIVE ||
    //     parseInt(project_state) === USER_STATE.FORBIDDEN)
    // ) {
    //   localStorage.removeItem("project_id");
    //   sessionStorage.removeItem("project_state");
    // }
    // if (getToken("accessToken")) {
    //   props.requestInit();
    // }
  }
  componentWillMount() {
    const currentRoute = window.location.pathname;
    if (
      getToken(ACCESS_TOKEN) &&
      ISOLATED_ROUTES_FROM_INIT.indexOf(currentRoute) < 0
    ) {
      console.log("in app");
      this.props.requestInit();
    }
  }

  // async componentDidMount() {
  //   const searchParam = await queryString.parse(document.location.search);
  //   if (
  //     searchParam &&
  //     Object.keys(searchParam).length === 1 &&
  //     searchParam.project_id
  //   ) {
  //     localStorage.setItem("project_id", searchParam.project_id);
  //     setTimeout(() => this.props.requestInit());
  //   }
  // }
  // componentDidUpdate(prevProps) {
  //   if (!isEqual(this.props.init, prevProps.init)) {
  //     this.changeLastPanelCookie();
  //   }
  // }

  layoutManage(item, key) {
    switch (item.layout) {
      case "centralize":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <CentralizeLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "dashboard":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <DashboardLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "tools.dashboard":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <ToolsDashboardLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "tools.fullpage":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <ToolsFullpageLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "fullpage":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <FullpageLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "setting":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <SettingLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
                init={this.props.init}
              />
            )}
          />
        );
      default:
        return (
          <Route
            key={key}
            exact
            path={item.path}
            component={item.component}
            options={item.options || {}}
          />
        );
    }
  }
  switchRoutes() {
    const { init } = this.props;
    return routes.map((route, key) => {
      if (
        init.data === null ||
        route === COMPANIES_LIST ||
        route.visibility === "trust"
      ) {
        // auth routes and main routes
        return this.layoutManage(route, key);
      } else {
        return null;
      }
    });
    // if (init.project_status) {
    //   //because in companies route, init request calls its is true
    //   // const purchase = routes.filter(
    //   // //   route => route.visibility === "" && route.path === "/purchase"
    //   // // );
    //   // const invitation = routes.filter(
    //   //   route => route.visibility === "all" && route.path === "/invitation"
    //   // );
    //   // // if (purchase[0].path === window.location.pathname) {
    //   // //   return purchase.map((route, key) => this.layoutManage(route, key));
    //   // // }
    //   //  if (invitation[0].path === window.location.pathname) {
    //   //   return invitation.map((route, key) => this.layoutManage(route, key));
    //   // } else {
    //   return routes.map((route, key) => {
    //     if (
    //       route.path === COMPANIES_LIST ||
    //       route.path === NEW_OR_EDIT_COMPANY ||
    //       route.path === PURCHASE ||
    //       route.path === INVITATION
    //     ) {
    //       return (
    //         <Route
    //           key={key}
    //           exact
    //           path={route.path}
    //           render={router => (
    //             <CentralizeLayout
    //               route={router}
    //               Component={route.component}
    //               options={route.options || {}}
    //             />
    //           )}
    //         />
    //       );
    //     } else {
    //       return null;
    //     }
    //   });
    //   // }
    // } else {
    //   return routes.map((route, key) => {
    //     if (
    //       (init.data === null && route.visibility !== "trust") ||
    //       (init.data !== null && route.visibility === "trust")
    //     ) {
    //       // auth routes and main routes
    //       return this.layoutManage(route, key);
    //     }
    //     // else if (
    //     //   init.data !== null &&
    //     //   (route.visibility === "trust")
    //     // ) {
    //     //   return this.layoutManage(route, key);
    //     // }
    //     else {
    //       return null;
    //     }
    //   });
    // }
  }

  mobileAlertShow() {
    if (!getToken("accessToken")) {
      return <MobileAlert />;
    }
  }
  // changeLastPanelCookie() {
  //   const { init } = this.props;
  //   const route = window.location.pathname;
  //   let cookie;
  //   if (route.startsWith(DASHBOARD_PETTY_CASHIER)) {
  //     cookie = PETTY_CASHIER_PANEL;
  //   } else if (route.startsWith(DASHBOARD_MANAGER)) {
  //     cookie = MANAGER_PANEL;
  //   }
  //   if (init.data && init.data.data && cookie) {
  //     const headerData = init.data.data;
  //     setCookie(
  //       `fav-panel-${headerData.user.id}-${headerData.project.id}`,
  //       cookie,
  //       "max"
  //     );
  //   }
  // }
  render() {
    const { init } = this.props;
    const accessToken = getToken(ACCESS_TOKEN);
    const projectUserId = localStorage.getItem(PROJECT_USER_ID);
    const currentRoute = window.location.pathname;
    if (
      init.loading &&
      accessToken &&
      ISOLATED_ROUTES_FROM_INIT.indexOf(currentRoute) < 0
    ) {
      return (
        <React.Fragment>
          <GlobalStyle />
          {init.serverInterruptStatus && (
            <Confirm
              show={init.serverInterruptStatus}
              content={{
                type: "danger",
                icon: "icon mapsa-notification",
                message: SERVER_INTERRUPT_MESSAGES[init.serverInterruptStatus],
                acceptButtonText: "بارگذاری مجدد",
                rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
              }}
              acceptHandler={() => {
                window.location.reload();
                this.props.changeServerInterruptStatus();
              }}
              rejectHandler={() => {
                this.props.changeServerInterruptStatus();
              }}
            />
          )}
          <Toast />
          <FullScreenLoading />
        </React.Fragment>
      );
    } else {
      if (!accessToken) {
        //auth routes
        if (AUTH_ROUTES.indexOf(currentRoute) < 0) {
          // current route is not auth route
          if (currentRoute === "/") {
            window.location.replace(LOGIN);
          } else {
            const redirectUrl = encodeURIComponent(
              window.location.pathname + window.location.search
            );
            window.location.replace(LOGIN + `?redirect=${redirectUrl}`);
          }
          return null;
        }
      } else if (accessToken) {
        //other routes after init loading ended
        if (
          !projectUserId &&
          ALLOWED_ROUTES_BEFORE_PROJECT_SELECTION.indexOf(currentRoute) < 0
        ) {
          window.location.replace(COMPANIES_LIST);
          return null;
        } else if (
          projectUserId &&
          FORBIDDEN_ROUTES_AFTER_PROJECT_SELECTION.indexOf(currentRoute) >= 0
        ) {
          window.location.replace("/");
        }
      }
      return (
        <ConnectedRouter history={history}>
          <FeedbackModal />
          <DownloadModal />
          <FeatureDeniedModal />
          <ImageUploadModal />
          <DownloadToast />
          <PanelSelectionModal />
          <PettyCashierSelectionModal />
          <TeamAddOrEditModal />
          {this.mobileAlertShow()}
          <GlobalStyle />
          <LongErrorModal />
          <GuestDeniedModal />
          <ChangeAccessDeniedWarning />

          {/*{init.data &&*/}
          {/*  init.data.data &&*/}
          {/*  !init.data.data.is_owner &&*/}
          {/*  init.data.data.project &&*/}
          {/*  init.data.data.project.premium_state === FREE && (*/}
          {/*    <GuestDeniedModal*/}
          {/*      status={true}*/}
          {/*      handleShow={show =>*/}
          {/*        this.setState({ accessDeniedModalShow: show })*/}
          {/*      }*/}
          {/*      shouldReload={true}*/}
          {/*      projectId={localStorage.getItem("project_id")}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*{init.serverInterruptStatus && (*/}
          {/*  <Confirm*/}
          {/*    show={init.serverInterruptStatus}*/}
          {/*    content={{*/}
          {/*      type: "danger",*/}
          {/*      icon: "icon mapsa-notification",*/}
          {/*      message: SERVER_INTERRUPT_MESSAGES[init.serverInterruptStatus],*/}
          {/*      acceptButtonText: "بارگذاری مجدد",*/}
          {/*      rejectButtonText: "باشه"*/}
          {/*    }}*/}
          {/*    acceptHandler={() => {*/}
          {/*      this.props.changeServerInterruptStatus();*/}
          {/*      window.location.reload();*/}
          {/*    }}*/}
          {/*    rejectHandler={() => {*/}
          {/*      this.props.changeServerInterruptStatus();*/}
          {/*    }}*/}
          {/*  />*/}
          {/*)}*/}

          <Toast />

          <Confirm
            show={init.completeUserInfoConfirmData.show}
            rejectHandler={() => this.props.completeUserInfoConfirmClose()}
            acceptHandler={() => {
              history.push(USER_ACCOUNT_SETTING_EDIT);
              this.props.completeUserInfoConfirmClose();
            }}
            close={() => this.props.completeUserInfoConfirmClose()}
            content={{
              type: "info",
              title: "تکمیل اطلاعات کاربری",
              message: COMPLETE_USER_PROFILE_CONFIRM(
                init.completeUserInfoConfirmData.name
              ),
              acceptButtonText: "بله",
              rejectButtonText: "خیر",
              icon: "icon mapsa-i-letter"
            }}
          />
          <Confirm
            show={init.completeProjectInfoConfirmData.show}
            rejectHandler={() =>
              this.props.completeProjectInfoConfirmClose(
                init.completeProjectInfoConfirmData.changeCookie
              )
            }
            acceptHandler={() => {
              this.props.completeProjectInfoConfirmClose(
                init.completeProjectInfoConfirmData.changeCookie
              );
              history.push({
                pathname: NEW_OR_EDIT_COMPANY,
                state: {
                  type: EDIT_MODE,
                  projectData: init.completeProjectInfoConfirmData.project
                }
              });
            }}
            close={() =>
              this.props.completeProjectInfoConfirmClose(
                init.completeProjectInfoConfirmData.changeCookie
              )
            }
            content={{
              type: "info",
              title: "تکمیل اطلاعات شرکت",
              message: COMPLETE_PROJECT_INFO_CONFIRM(
                init.completeProjectInfoConfirmData.name
              ),
              acceptButtonText: "بله",
              rejectButtonText: "خیر",
              icon: "icon mapsa-i-letter"
            }}
          />

          <Switch>
            {!init.data && init.serverInterruptMessage ? (
              <Route
                component={() => (
                  <InitError message={init.serverInterruptMessage} />
                )}
              />
            ) : null}
            {!init.serverInterruptMessage && this.switchRoutes()}
            <Route component={NoMatch} />;
          </Switch>
        </ConnectedRouter>
      );
      // let authRoutes = [
      //   "/login",
      //   "/register",
      //   "/forget",
      //   "/verify",
      //   "/reset-password"
      // ];
      // if (authRoutes.indexOf(window.location.pathname) < 0) {
      //   if (
      //     (!getToken("accessToken") &&
      //       window.location.pathname !== "/login") ||
      //     (getToken("accessToken") && init.userNotVerified)
      //   ) {
      //     window.location.replace("/login");
      //     return null;
      //   }
      // } else {
      //   if (
      //     getToken("accessToken") &&
      //     window.location.pathname !== "/verify" &&
      //     window.location.pathname !== "/companies" &&
      //     (window.location.pathname !== "/login" || !init.userNotVerified) &&
      //     window.location.pathname !== "/purchase" &&
      //     window.location.pathname !== "/invitation" &&
      //     window.location.pathname !== "/register"
      //   ) {
      //     window.location.replace("/");
      //     return null;
      //   }
      // }
      // if (getToken("accessToken") && window.location.pathname === "/" && init.data && init.data.project === null){
      //   window.location.replace("/companies");
      //   return null;
      // }
    }
  }
}
const mapStateToProps = store => {
  return {
    init: store.Init
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestInit: () => {
      dispatch(InitAction.get());
    },
    changeServerInterruptStatus: status => {
      dispatch(InitAction.changeServerInterruptStatus(status));
    },
    completeUserInfoConfirmClose: () => {
      dispatch(InitAction.completeUserInfoConfirmClose());
    },
    completeProjectInfoConfirmClose: changeCookie => {
      dispatch(InitAction.completeProjectInfoConfirmClose(changeCookie));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
